<template lang="">
  <div class="row" v-if="price > 0">
    <div class="col-md-12">
      <div class="checkbox">
        <label>
          <input
            type="checkbox"
            name="verkostung"
            id="verkostung"
            value="1"
            v-model="checked"
          />
          {{ message }}
        </label>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  price: {
    type: Number,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  language: {
    type: Number,
    required: true,
  },
});

const checked = ref(0);

const lang = computed(() => {
  return props.language == 1 ? "de-DE" : "en-EN";
});

const message = computed(() => {
  const price = Intl.NumberFormat(lang, {
    style: "currency",
    currency: "EUR",
  }).format(props.price / 100);
  return props.language == 1
    ? `${props.text} für ${price} pro Person`
    : `${props.text} for ${price} per person`;
});
</script>
<style lang=""></style>
